import { MapPin } from "lucide-react";

// Koordinater verifierade med Nominatim 2026-04-16
// Markerade med (V) = Nominatim-verifierad adress, (E) = estimerad position nära centrum
const KNOWN_LOCATIONS = {
  // === BACKE === (centrum: 63.8107, 16.4058)
  "ICA Nära Backe":              { lat: 63.811284, lng: 16.405653, address: "Centrumvägen 7, 883 72 Backe" },         // V
  "Byservicekontor Backe":       { lat: 63.811000, lng: 16.405100, address: "Torgvägen 1A, 880 50 Backe" },           // V
  "Fjällsjö kyrka":              { lat: 63.814223, lng: 16.397588, address: "Kyrkvägen 50, 880 50 Backe" },           // V
  "Backe Camping":               { lat: 63.812891, lng: 16.410311, address: "Stenhammarsvägen, 880 50 Backe" },       // V
  "Stenhammaren badplats":       { lat: 63.812891, lng: 16.410311, address: "Stenhammarsvägen, Backe" },              // V
  "Fjällsjöskolan":              { lat: 63.811100, lng: 16.403100, address: "Läkarvägen 22, 883 72 Backe" },          // V
  "Riddarens förskola":          { lat: 63.806331, lng: 16.409150, address: "Lasarettsvägen 9, 883 72 Backe" },       // V
  "Landsomberget":               { lat: 63.844400, lng: 16.353300, address: "Backe (slalombacke)" },                   // E
  "Räddningstjänsten Backe":     { lat: 63.812100, lng: 16.415100, address: "Kuskvägen 4, Backe" },                   // E
  "Backe Jaktskyttebana":        { lat: 63.812003, lng: 16.399659, address: "Strandvägen 37, Backe" },                // V
  "FjällsjöTerminalen":          { lat: 63.804551, lng: 16.429068, address: "Stationsvägen 400, Backe" },             // V
  "Nr 72 mat och bar":           { lat: 63.811200, lng: 16.405500, address: "Backe centrum" },                         // E
  "Kafé Violen":                 { lat: 63.807273, lng: 16.408503, address: "Lasarettsvägen, Backe HC" },              // V
  "Fjällsjö Åkeri AB":           { lat: 63.807500, lng: 16.409500, address: "Lasarettsvägen 25B, Backe" },            // E
  "Sunnansjögårdens jakt & fiske": { lat: 63.830000, lng: 16.370000, address: "Backe" },                              // E
  "Vängel Entreprenad AB":       { lat: 63.820000, lng: 16.350000, address: "Vängel 380, 883 94 Backe" },             // E
  "SCA Skog AB (kontor Backe)":  { lat: 63.810000, lng: 16.406500, address: "Gamla Vägen 9, Backe" },                 // E
  "NISAB Backe AB":              { lat: 63.811500, lng: 16.407000, address: "Backe" },                                 // E
  "Backe Bygg & Snickeri AB":    { lat: 63.811000, lng: 16.404500, address: "Backe" },                                // E
  "Bergvalls Maskinteknik (BMT)": { lat: 63.814223, lng: 16.397588, address: "Kyrkvägen 2, Backe" },                  // V
  "Backe Begravningsbyrå AB":    { lat: 63.826409, lng: 16.349626, address: "Johannesbergsvägen 3, Backe" },          // V
  "Byggjanne i Backe AB":        { lat: 63.804551, lng: 16.429068, address: "Stationsvägen 52, Backe" },              // V
  "Hedströms Bygg Och Alltjänst": { lat: 63.812000, lng: 16.406000, address: "Söredsta 275, Backe" },                 // E
  "Lasarettsvägen 16, Backe":    { lat: 63.807273, lng: 16.408503, address: "Lasarettsvägen 16, Backe" },             // V

  // === ROSSÖN === (centrum: 63.9228, 16.3387)
  "ICA Nära Rossön":             { lat: 63.924309, lng: 16.328859, address: "Hotingsvägen 7, 883 95 Rossön" },        // V
  "Rossöns Sport & Färg":        { lat: 63.924500, lng: 16.328000, address: "Rossön" },                                // E nära ICA
  "Rossöns Golfklubb":           { lat: 63.931980, lng: 16.314554, address: "Näset 17, Rossön" },                      // V (Hotingsvägen)
  "Rossön Camping":              { lat: 63.922000, lng: 16.345000, address: "Rossön" },                                // E
  "Mählers":                     { lat: 63.921500, lng: 16.320000, address: "Industriområdet, Rossön" },               // E
  "Bodums hembygdsgård":         { lat: 63.935200, lng: 16.385000, address: "Hällnäset 130, Rossön" },                // E
  "Rossöns Stenåldersmuseum":    { lat: 63.923000, lng: 16.340000, address: "Öhnvägen 5, Rossön" },                   // E
  "Rossöns Folkets Hus":         { lat: 63.922843, lng: 16.338730, address: "Rossön centrum" },                        // V
  "Rossöns IF skidstadion":      { lat: 63.926000, lng: 16.330000, address: "Rossön" },                                // E
  "Rossö Center":                { lat: 63.922800, lng: 16.337000, address: "Bodumsvägen 2, Rossön" },                 // E
  "Ringvägen 16, Rossön":        { lat: 63.922200, lng: 16.335500, address: "Ringvägen 16, 883 95 Rossön" },          // E
  "Rossöns Däckservice":         { lat: 63.931980, lng: 16.314554, address: "Hotingsvägen 13, Rossön" },               // V
  "Finlanda flygfält":           { lat: 63.911887, lng: 16.322890, address: "Önvägen, Backvall, Rossön" },             // V!
  "Rossö Potatis":               { lat: 63.933055, lng: 16.365633, address: "Bölen 253, 883 95 Rossön" },             // V
  "K-Gas Rossön":                { lat: 63.923800, lng: 16.335000, address: "Rossön" },                                // E
  "Biograf Valhall":             { lat: 63.923400, lng: 16.337000, address: "Rossön" },                                // E
  "Elisabeth Söderströms Tapetserarverkstad": { lat: 63.920584, lng: 16.340467, address: "Backevägen 12A, Rossön" },   // V
  "Rossön Camp":                 { lat: 63.920000, lng: 16.350000, address: "Lesjön, Rossön" },                        // E
  "Rossöns Allservice":          { lat: 63.922600, lng: 16.337500, address: "Rossön" },                                // E
  "Perssons VVS Rossön AB":      { lat: 63.922500, lng: 16.335000, address: "Rossön" },                                // E
  "Rossöns Dem & Rep – Manne Olsson": { lat: 63.933055, lng: 16.365633, address: "Bölen 105, 883 95 Rossön" },        // V
  "Bollsbergets naturreservat":  { lat: 63.917400, lng: 16.250200, address: "3-4 km väster om Rossön" },               // E

  // === STRÖMSUND ===
  "Strömsunds hälsocentral":     { lat: 63.858600, lng: 15.565700, address: "Lövbergavägen 37, Strömsund" },          // V
};

function getGoogleMapsUrl(name, location) {
  if (location) return `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(name + ", Strömsund, Sweden")}`;
}

export function MapLink({ name, className = "" }) {
  const location = KNOWN_LOCATIONS[name];
  const url = getGoogleMapsUrl(name, location);
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
      data-testid={`map-link-${name.toLowerCase().replace(/[\s,\/&]+/g, "-").slice(0, 30)}`}
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-pine hover:text-pine-hover no-underline transition-colors ${className}`}>
      <MapPin size={14} /> Visa på karta
    </a>
  );
}

export function MapCard({ name, className = "" }) {
  const location = KNOWN_LOCATIONS[name];
  if (!location) return null;
  const mapsUrl = getGoogleMapsUrl(name, location);
  const embedUrl = `https://maps.google.com/maps?q=${location.lat},${location.lng}&z=16&output=embed&t=k`;
  return (
    <a href={mapsUrl} target="_blank" rel="noopener noreferrer"
      data-testid={`map-card-${name.toLowerCase().replace(/[\s,\/&]+/g, "-").slice(0, 30)}`}
      className={`block rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow no-underline ${className}`}>
      <div className="w-full h-36 bg-bone-alt relative">
        <iframe src={embedUrl} title={`Karta: ${name}`} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen className="w-full h-full border-0 pointer-events-none" />
      </div>
      <div className="bg-white px-3 py-2 flex items-center gap-2">
        <MapPin size={14} className="text-pine shrink-0" />
        <div className="min-w-0">
          <p className="text-sm font-medium text-ink truncate">{name}</p>
          <p className="text-xs text-muted-foreground truncate">{location.address}</p>
        </div>
      </div>
    </a>
  );
}

export function StreetViewCard({ name, className = "" }) {
  const location = KNOWN_LOCATIONS[name];
  if (!location) return null;
  const embedUrl = `https://maps.google.com/maps?q=${location.lat},${location.lng}&z=16&output=embed&t=k`;
  const svUrl = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${location.lat},${location.lng}`;
  const mapsUrl = getGoogleMapsUrl(name, location);
  return (
    <div data-testid={`sv-card-${name.toLowerCase().replace(/[\s,\/&]+/g, "-").slice(0, 30)}`}
      className={`rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow ${className}`}>
      <a href={svUrl} target="_blank" rel="noopener noreferrer" className="block w-full h-48 bg-bone-alt relative">
        <iframe src={embedUrl} title={`Karta: ${name}`} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen className="w-full h-full border-0 pointer-events-none" />
      </a>
      <div className="bg-white px-3 py-2.5">
        <div className="flex items-center gap-2 mb-1">
          <MapPin size={14} className="text-pine shrink-0" />
          <p className="text-sm font-medium text-ink truncate">{name}</p>
        </div>
        <p className="text-xs text-muted-foreground mb-1.5">{location.address}</p>
        <div className="flex gap-3">
          <a href={mapsUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-falu hover:text-falu-hover no-underline">Google Maps</a>
          <a href={svUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-pine hover:text-pine-hover no-underline">Street View</a>
        </div>
      </div>
    </div>
  );
}

export { KNOWN_LOCATIONS, getGoogleMapsUrl };
